import { Component, OnInit, OnDestroy } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { 
  logOutOutline, 
  personOutline, 
  lockClosedOutline,
  logInOutline,
  homeOutline,
  settingsOutline,
  helpCircleOutline,
  calendarOutline,
  closeOutline,
  informationCircleOutline,
  trashOutline,
  pencilOutline,
  arrowBackOutline,
  arrowForwardOutline,
  backspaceOutline,
} from 'ionicons/icons';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(private versionCheckService: VersionCheckService) {
    // Register commonly used icons globally
    addIcons({
      'log-out-outline': logOutOutline,
      'person-outline': personOutline,
      'lock-closed-outline': lockClosedOutline,
      'log-in-outline': logInOutline,
      'home-outline': homeOutline,
      'settings-outline': settingsOutline,
      'help-circle-outline': helpCircleOutline,
      'calendar-outline': calendarOutline,
      'close-outline': closeOutline,
      'information-circle-outline': informationCircleOutline,
      'trash-outline': trashOutline,
      'pencil-outline': pencilOutline,
      'arrow-back-outline': arrowBackOutline,
      'arrow-forward-outline': arrowForwardOutline,
      'backspace-outline': backspaceOutline
    });
  }

  async ngOnInit() {
    // Check version support when app starts
    await this.versionCheckService.checkVersionSupport();
  }

  ngOnDestroy() {
    // Cleanup version check service listeners
    if (this.versionCheckService && typeof this.versionCheckService.ngOnDestroy === 'function') {
      this.versionCheckService.ngOnDestroy();
    }
  }
}
